import { writable } from "svelte/store";

export const email = writable("");
export const authType = writable("");
